module.exports = __webpack_public_path__ + "static/img/img-ygd.965a5c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daping/img-ygd.png
// module id = M0K5
// module chunks = 0